import { createContext, useContext } from 'react';
import { CLASSIC_VARIANT, type AppearanceVariant } from './variants';

export const AppearanceContext = createContext<{
  variant: AppearanceVariant;
  select: (id: string) => void;
}>({ variant: CLASSIC_VARIANT, select: () => undefined });
export function useAppearance(): React.ContextType<typeof AppearanceContext> {
  return useContext(AppearanceContext);
}
